import React from 'react';

import img1 from '../assets/images/AdobeStock_280820527.jpg';
import img2 from '../assets/icons/mundschutz.svg';
import img3 from '../assets/icons/einmal-handschuhe.svg';
import img4 from '../assets/icons/handdesinfektion.svg';
import img5 from '../assets/icons/flaeche.svg';
import img6 from '../assets/icons/schuerze.svg';
import img7 from '../assets/icons/fingerlinge.svg';
import img8 from '../assets/icons/betttuecher.svg';
import img9 from '../assets/icons/FFP2.svg';
import img10 from '../assets/images/Rechteck.jpg';
import img11 from '../assets/images/Rechteck 62-1.jpg';
import img12 from '../assets/images/Rechteck 62.jpg';
import img13 from '../assets/images/frau-produkte.png';
import img14 from '../assets/images/frau-paket-lieferung.png';
import img15 from '../assets/images/frau-show.png';
import img16 from '../assets/images/frau-perfekt.png';
import img17 from '../assets/images/frau-produkte.png';
import img18 from '../assets/images/frau-paket-lieferung.png';
import img19 from '../assets/images/frau-show.png';
import img21 from '../assets/images/Motiv-News1.jpg';
import img22 from '../assets/images/Motiv-News2.jpg';
import img23 from '../assets/images/Motiv-News3.jpg';
import img24 from '../assets/images/AdobeStock_497172096.jpg';
import img25 from '../assets/images/AdobeStock_432153638.jpg';
import img26 from '../assets/images/AdobeStock_419808796.jpg';
import checkBlue from '../assets/icons/check-blue.svg';
import dashedline from '../assets/icons/dashed-line.svg';
import contact from '../assets/icons/contact-online.svg';
import mail from '../assets/icons/contact-mail.svg';
import fon from '../assets/icons/contact-fon.svg';
import fax from '../assets/icons/contact-fax.svg';
import checkCircle from '../assets/icons/check-circle.svg';

import pfeil from '../assets/icons/Pfeil.svg';
import quotation from '../assets/icons/right-quotation-mark.png';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Settings from '../components/Settings';
import { useNavigate } from 'react-router-dom';
const Homepage = () => {
  const navigate = useNavigate();
  return (
    <div id='homepage'>
      {/* HEAD */}

      {/* NAV */}
      <Navbar />
      {/* HERO  */}
      <section className='container-xxl px-0 px-xxl-0' id='hero'>
        <div className=' banner'>
          <div>
            <h1 className='mb-2'>Erhalten Sie Pflegehilfsmittel</h1>
            <h1>
              im Wert von 40€* pro Monat <span>gratis!</span>
            </h1>
          </div>
          <div>
            <button className='btn-primary'>Zum Konfigurator</button>
          </div>
        </div>
      </section>
      {/* HERO INFOS  */}
      <section className='container-xxl px-xxl-0' id='hero-infos'>
        <div className='row px-2 px-lg-4 px-xxl-0'>
          <div className='col-12 col-lg-6 mb-4 mb-lg-0 pe-1'>
            <h2 className='mb-3'>Donec vitae sapien H1</h2>
            <p className='mb-3'>
              In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu
              pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi.
              Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae,
              eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus.
              Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet.
              Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui.
              Etiam rhoncus.
            </p>
            <p>
              Maecenas tempus, tellus eget <u>condimentum rhoncus</u>, sem quam semper libero, sit
              amet <u>adipiscing sem neque</u> sed ipsum. Nam quam nunc, blandit vel, luctus
              pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae
              sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros
              faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales
              sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,
              quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus
              quam, <u>scelerisque ut</u>, mollis sed, nonummy id, metus.
            </p>
            <p />
          </div>
          <div className='col-12 col-lg-6 d-flex align-items-center'>
            <img src={img1} alt='img' />
          </div>
        </div>
      </section>
      {/* PflegehilfeSet */}
      <section id='PflegehilfeSet' className='py-5 ' style={{ position: 'relative' }}>
        <div className='container-xxl px-lg-4 px-xxl-0'>
          <div className='container-xxl px-3 px-md-5 px-xxl-0'>
            <div className='mb-5'>
              <h2>PflegehilfeSet individuell konfigurieren</h2>
              <p className='my-2'>
                Wählen Sie aus diesen Produkten Ihr individuelles PflegehilfeSet
              </p>
            </div>
            <div>
              <div className='row  gy-5 px-3 px-lg-0'>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img2} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Mundschutz</p>
                    <small>50 Stk.</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img3} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Einmalhandschuhe </p>
                    <small>100 Stk.</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img4} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Handdesinfektion</p>
                    <small> 500 ml</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img5} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Flächendesinfektion l</p>
                    <small>500 m</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img6} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Eimal-Schutzschürze </p>
                    <small>100 Stk.</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img7} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Fingerlinge</p>
                    <small>100 Stk.</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img8} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>Bettschutzeinlagen </p>
                    <small>25 Stk.</small>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-lg-3  setcard'>
                  <div className='py-3 d-flex align-items-center'>
                    <img src={img9} alt='mundschutz' />
                  </div>
                  <div className='pt-2 pb-4'>
                    <p className='my-2'>FFP2-Maske</p>
                    <small>6 Stk.</small>
                  </div>
                </div>
              </div>
            </div>
            <button className='btn-primary mt-5'>Zum Konfigurator</button>
          </div>
        </div>
      </section>
      {/* Vorteile  */}
      <section className='container-xxl px-xxl-0' id='vorteile'>
        <div className='row px-2 px-lg-4 px-xxl-0  gy-4'>
          <div className='col-12 col-lg-6 d-flex align-items-center'>
            <img src={img10} alt='img' style={{ width: '100%' }} />
          </div>
          <div className='col-12 col-lg-6 mb-4 mb-lg-0 d-flex align-content-between flex-column justify-content-between'>
            <h2 className='mb-3 mb-xl-0'>Vorteile</h2>
            <ul>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>
                  Unbürokratische Abrechnung: Wir übernehmen die Beantragung und die Abrechnung mit
                  der Pflegekasse für Sie.
                </p>
              </li>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>
                  Kostenersparnis: Die Pflegekasse übernimmt die Kosten zu 100 % - das
                  PflegehilfeSet ist damit für Sie völlig kostenlos.
                </p>
              </li>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>
                  Zuverlässigkeit: Sie erhalten jeden Monat die wichtigsten Pflegehilfsmittel -
                  direkt zu sich nach Hause.
                </p>
              </li>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>Qualität: Die PflegehilfeSets enthalten nur qualitativ hochwertige Produkte.</p>
              </li>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>
                  Zeitersparnis: Sparen Sie die Zeit, die Sie sonst mit dem Einkauf der
                  Pflegehilfsmittel verbringen.
                </p>
              </li>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>
                  Flexibilität: Sie können den Inhalt des PflegehilfeSets jederzeit anpassen - ganz
                  nach Ihren Bedürfnissen.
                </p>
              </li>
              <li className='d-flex align-content-center'>
                <span className=''>
                  <img src={checkBlue} alt='check' className='me-2 mt-1' />
                </span>
                <p>
                  Risikofreie Bestellung: Keine Vertragsbindung, keine Zuzahlung - Sie können das
                  PflegehilfeSet jederzeit wieder abbestellen und müssen keine versteckten Kosten
                  befürchten.
                </p>
              </li>
            </ul>
            <a href='#' className=' ms-4 mt-3 mt-lg-0'>
              Mehr zum Bestellprozess{' '}
              <span>
                <img src={pfeil} alt='Mehr zum Bestellprozess' className=' ms-3' />
              </span>
            </a>
          </div>
        </div>
      </section>
      {/* Wissenswertes */}
      <section className='py-10' id='Wissenswertes'>
        <div className='container-xxl px-lg-4 px-xxl-0'>
          <div className='container-xxl px-3 px-xxl-0'>
            <h2 className='mb-4'>Wissenswertes zur Pflege und Pflegehilfsmitteln</h2>
            <div className='card'>
              <div>
                <div className='mb-3'>
                  <img src={img11} alt='img' className='card-img' />
                </div>
                <div>
                  <h4>PflegehilfeSet zusammenstellen</h4>
                  <p className='mt-3 mb-4'>
                    Wählen Sie aus unseren 6 PflegehilfeSets oder stellen Sie sich Ihre
                    Pflegehilfsmittel mit unserem Konfigurator individuell zusammen.
                  </p>
                </div>
                <div>
                  <a href='#' className=' mt-3 mt-lg-0'>
                    PflegehilfeSet wählen
                    <span>
                      <img src={pfeil} alt='Mehr zum Bestellprozess' className=' ms-1' />
                    </span>
                  </a>
                </div>
              </div>
              <div className='d-flex flex-column'>
                <div className='mb-3'>
                  <img src={img24} alt='img' className='card-img' />
                </div>
                <div className='d-flex flex-column '>
                  <div>
                    <h4>Pflegehilfsmittel</h4>
                    <p className='mt-3 mb-4'>
                      Informieren Sie sich hier über die Pflegehilfsmittel, die in unseren
                      PflegehilfeSets enthalten sind.
                    </p>
                  </div>
                  <div className='d-flex align-items-xl-end '>
                    <a href='#' className=' mt-3 mt-lg-0'>
                      Zu den Pflegehilfsmitteln
                      <span>
                        <img src={pfeil} alt='Mehr zum Bestellprozess' className=' ms-1' />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className='mb-3'>
                  <img src={img25} alt='img' className='card-img' />
                </div>
                <div className='d-flex flex-column justify-content-between'>
                  <div>
                    <h4>Ihre Vorteile</h4>
                    <p className='mt-3 mb-4'>
                      Ihre Vorteile bei der Bestellung eines PflegehilfeSets auf einen Blick.
                    </p>
                  </div>
                  <div className='d-flex align-items-end'>
                    <a href='#' className=' mt-3 mt-lg-0'>
                      Vorteile ansehen
                      <span>
                        <img src={pfeil} alt='Mehr zum Bestellprozess' className=' ms-1' />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className='mb-3'>
                  <img src={img12} alt='img' className='card-img' />
                </div>
                <div className='d-flex flex-column justify-content-between'>
                  <div>
                    <h4>Pflegeshop</h4>
                    <p className='mt-3 mb-4'>
                      Besuchen Sie unseren Standard Systeme Onlineshop für eine große Auswahl
                      weiterer Pflegehilfsmittel.
                    </p>
                  </div>
                  <div className='d-flex align-items-end'>
                    <a href='#' className=' mt-3 mt-lg-0'>
                      Zum Onlineshop
                      <span>
                        <img src={pfeil} alt='Mehr zum Bestellprozess' className=' ms-1' />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Wie funktioniert */}
      <section className='container-xxl px-3 px-xxl-0 py-10' id='wieFunktioniert'>
        <div className='container-xxl px-0 ' style={{ position: 'relative' }}>
          <h2 className=''>Wie funktioniert der Antrag Ihres PflegehilfeSets?</h2>
          <div className='map '>
            <div className='div-1'>
              <div className='component-img'>
                <img src={img13} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 1</h4>
                <h5>Bestellung</h5>
                <p>
                  Wählen Sie die benötigten Produkte aus und konfigurieren Sie Ihr individuelles Set
                  im Wert von 40 €. Wir stehen Ihnen auf allen Kommunikationswegen für die
                  Bestellung zur Verfügung.
                </p>
              </div>
            </div>
            <div className='div-2'>
              <div className='component-img'>
                <img src={img14} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 2</h4>
                <h5>Lieferung</h5>
                <p>
                  In der Regel erhalten Sie Ihre Bestellung kürzester Zeit direkt nach Hause bzw.
                  zum gewünschten Einsatzort.
                </p>
              </div>
            </div>
            <div className='div-3'>
              <div className='component-img'>
                <img src={img15} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 3</h4>
                <h5>Beantragung</h5>
                <p>
                  Schon nach Abschluss Ihrer Bestellung leiten wir für Sie die Beantragung und
                  Abrechnung bei der Pflegekasse ein. Sie brauchen sich um nichts kümmern.
                </p>
              </div>
            </div>
            <div className='div-4'>
              <div className='component-img'>
                <img src={img16} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 4</h4>
                <h5>Abwicklung</h5>
                <p>
                  Sie erhalten monatlich Ihr PflegehilfeSet, das Sie bequem an Ihre Bedürfnisse
                  anpassen können. Es gibt keine versteckten Kosten und keine Vertragsbindung - nur
                  volle Flexibilität für Sie.
                </p>
              </div>
            </div>
            <div className='div-5'>
              <button className='btn-primary'>Zum Konfigurator</button>
            </div>
            <div className='div-6'>
              <img src={dashedline} alt='' />
            </div>
          </div>
          <div className='map-mobile px-1'>
            <div className='div-1'>
              <div className='component-img'>
                <img src={img17} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 1</h4>
                <h5>Bestellung</h5>
                <p>
                  Wählen Sie die benötigten Produkte aus und konfigurieren Sie Ihr individuelles Set
                  im Wert von 40 €. Wir stehen Ihnen auf allen Kommunikationswegen für die
                  Bestellung zur Verfügung.
                </p>
              </div>
            </div>
            <div className='div-2'>
              <div className='component-img'>
                <img src={img18} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 2</h4>
                <h5>Lieferung</h5>
                <p>
                  In der Regel erhalten Sie Ihre Bestellung kürzester Zeit direkt nach Hause bzw.
                  zum gewünschten Einsatzort.
                </p>
              </div>
            </div>
            <div className='div-3'>
              <div className='component-img'>
                <img src={img19} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 3</h4>
                <h5>Beantragung</h5>
                <p>
                  Schon nach Abschluss Ihrer Bestellung leiten wir für Sie die Beantragung und
                  Abrechnung bei der Pflegekasse ein. Sie brauchen sich um nichts kümmern.
                </p>
              </div>
            </div>
            <div className='div-4'>
              <div className='component-img'>
                <img src={img19} alt='' />
              </div>
              <div className='component-text'>
                <h4>Schritt 4</h4>
                <h5>Abwicklung</h5>
                <p>
                  Sie erhalten monatlich Ihr PflegehilfeSet, das Sie bequem an Ihre Bedürfnisse
                  anpassen können. Es gibt keine versteckten Kosten und keine Vertragsbindung - nur
                  volle Flexibilität für Sie.
                </p>
              </div>
            </div>
            <div className='div-5'>
              <button className='btn-primary '>Zum Konfigurator</button>
            </div>
          </div>
        </div>
        <div className='container-xxl px-2 px-xxl-0 second mt-5 mt-xl-3'>
          <h2 className='pt-5 mb-2 pt-xl-0'>Wie kann ich ein PflegehilfeSet beantragen?</h2>
          <p className='mb-4'>Sie haben vier Möglichkeiten einen Antrag zu stellen.</p>
          <div className='d-flex px-2 px-md-5 px-xxl-0' style={{ columnGap: '2rem' }}>
            <div>
              <div>
                <div className='width:100%'>
                  <img src={contact} alt='img' className='card-img' />
                </div>
                <div>
                  <h4>Online bestellen &amp; Antrag stellen</h4>
                  <p className='mt-3 mb-4'>
                    Wählen Sie Ihre passende Kombination aus den Pflegehilfe-Produkten im Wert von
                    40,- Euro aus. Bestellen Sie diese bequem nach Hause. Wir stellen für Sie den
                    Antrag bei der Pflegekasse.
                  </p>
                </div>
              </div>
              <div>
                <button className='btn-primary my-3 my-lg-0'>Zum Konfigurator</button>
              </div>
            </div>
            <div>
              <div>
                <div className='width:100%'>
                  <img src={mail} alt='img' className='card-img' />
                </div>
                <div>
                  <h4>E-Mail senden</h4>
                  <p className='mt-3 mb-4'>
                    Senden Sie uns Ihre Antragsformulare einfach ausgefüllt und unterschrieben per
                    E-Mail zu.{' '}
                  </p>
                  <p>
                    <u>Antragsformular herunterladen</u>{' '}
                  </p>
                </div>
              </div>
              <div>
                <button className='btn-primary my-3 my-lg-0'>E-Mail senden</button>
              </div>
            </div>
            <div>
              <div>
                <div className='width:100%'>
                  <img src={fon} alt='img' className='card-img' />
                </div>
                <div>
                  <h4>Per Telefon beantragen</h4>
                  <p className='mt-3 mb-4'>
                    IUnser Kunden-Service hilft Ihnen gern telefonisch bei der Aufnahme Ihrer
                    Antragsdaten und Pflegehilfsmittel-Bestellung weiter.{' '}
                  </p>
                  <p className='phone-num'>0800 501 56 37</p>
                  <p className='mb-3'>
                    Mo - Do: 08:00 – 16:45 Uhr <br />
                    Fr: 08:00 – 15:00 Uhr
                  </p>
                </div>
              </div>
              <div>
                <button className='btn-primary my-3 my-lg-0'>Direkt anrufen</button>
              </div>
            </div>
            <div>
              <div>
                <div>
                  <img src={fax} alt='img' className='card-img' />
                </div>
                <div>
                  <h4>Per Fax beantragen</h4>
                  <p className='mt-3 mb-4'>
                    Senden Sie uns Ihre Antragsformulare einfach ausgefüllt und unterschrieben
                    kostenfrei per Fax zu.
                  </p>
                  <p>
                    <u>Antragsformular herunterladen</u>
                  </p>
                  <p className='phone-num mt-3 '>0800 1010978</p>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
      {/*Kunden*/}
      <section id='kunden'>
        <div className='container-xxl px-0'>
          <div className='big-square px-3 px-xxl-0'>
            <div className='py-5'>
              <h2 className='mb-2'>Das sagen unsere Kunden</h2>
              <p className='mx-auto' style={{ width: '85%' }}>
                Feedback auf dem unabhängigen Portal von Trusted Shops
              </p>
            </div>
            <div className='small-square'>
              <div>
                <span>
                  <img src={quotation} alt='' />
                </span>
                <h2 className='mt-4'>Hat alles super geklappt</h2>
              </div>
              <div>
                <p className='mb-3'>
                  Datum der Veröffentlichung: 03.01.2022 <br /> Datum der Kaufleistung: 20.12.2021
                </p>
                <div className='carousel-indicators d-flex justify-content-center'>
                  <div>
                    {' '}
                    <button />{' '}
                  </div>
                  <div className='mx-2'>
                    {' '}
                    <button />{' '}
                  </div>
                  <div>
                    {' '}
                    <button />{' '}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* News */}
      <section className='container py-10 px-3 px-lg-2' id='news'>
        <div className='title'>
          <h2 className='mb-2'>News</h2>
          <p>Neuigkeiten, Angebote und vieles mehr</p>
        </div>
        <div className='cards'>
          <div className='card'>
            <img src={img21} alt='news1' />
            <div className='p-3'>
              <small>11.01.2022</small>
              <br />
              <a href='#'>
                Verlosung von 2 Humorworkshops „Humor hilft Pflegen“ von der Stiftung HUMOR HILFT
                HEILEN
              </a>
            </div>
          </div>
          <div className='card'>
            <img src={img22} alt='news2' />
            <div className='p-3'>
              <small>08.12.2021</small>
              <br />
              <a href='#'>
                Aktuelle Angebote aus unserem E-Mail-Newletter Die Formulierungshilfen 2022 sind
                erschienen!
              </a>
            </div>
          </div>
          <div className='card'>
            <img src={img23} alt='news1' />
            <div className='p-3'>
              <small>12.11.2021</small>
              <br />{' '}
              <a href='#' className='my-3'>
                Die Formulierungshilfen 2022 sind erschienen!
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Rechtliche */}
      <section className='container-xxl py-10 px-0 px-lg-5 px-xxl-0' id='rechtliche'>
        <img src={img26} alt='' style={{ float: 'right' }} className='ms-3 mb-3' />
        <div className='document px-3'>
          <h2 className='mb-4'>Rechtliche Rahmenbedingungen</h2>
          <p>
            {' '}
            Die Basis für das PflegehilfeSet bildet § 40 SGB XI, nach dem die Pflegekasse die Kosten
            für Pflegehilfsmittel zum Verbrauch im Wert von 40 € pro Monat übernimmt.{' '}
            <b>Voraussetzungen</b> dafür sind:
          </p>
          <ul className='mb-4'>
            <li className='d-flex '>
              <img src={checkCircle} alt='' className='me-2 mb-2' />
              <p>
                Bestehen eines <u>Pflegegrades</u>{' '}
              </p>
            </li>
            <li className='d-flex'>
              <img src={checkCircle} alt='' className='me-2 mb-2' />
              <p>Pflege zuhause</p>
            </li>
            <li className='d-flex'>
              <img src={checkCircle} alt='' className='me-2 mb-2' />
              <p>
                Pflege durch eine Privatperson wie zum Beispiel einen Angehörigen (auch, wenn die
                Person durch einen Pflegedienstunterstützt wird)
              </p>
            </li>
          </ul>
          <p>Lassen Sie sich Ihren Anspruch auf Unterstützung nicht entgehen. Wir helfen Ihnen!</p>
          <p>
            Weitere Infos finden Sie hier: Pflegehilfsmittel beantragen, Pflegesachleistung,
            Pflegebedürftigkeit, Pflegehilfsmittel Liste, Pflegebox
          </p>
          <p> Hier können Sie den Gesetzestext nachlesen:</p>
          <p>
            {' '}
            <b>§ 40 SGB XI</b> <br /> (1) Pflegebedürftige haben Anspruch auf Versorgung mit
            Pflegehilfsmitteln, die zur Erleichterung der Pflege oder zur Linderung der Beschwerden
            des Pflegebedürftigen beitragen oder ihm eine selbständigere Lebensführung ermöglichen,
            soweit die Hilfsmittel nicht wegen Krankheit oder Behinderung von der
            Krankenversicherung oder anderen zuständigen Leistungsträgern zu leisten sind. Die
            Pflegekasse überprüft die Notwendigkeit der Versorgung mit den beantragten
            Pflegehilfsmitteln unter Beteiligung einer Pflegefachkraft oder des Medizinischen
            Dienstes. Entscheiden sich Versicherte für eine Ausstattung des Pflegehilfsmittels, die
            über das Maß des Notwendigen hinausgeht, haben sie die Mehrkosten und die dadurch
            bedingten Folgekosten selbst zu tragen. § 33 Abs. 6 und 7 des Fünften Buches gilt
            entsprechend.
          </p>
          <p>
            (2) Die Aufwendungen der Pflegekassen für zum Verbrauch bestimmte Pflegehilfsmittel
            dürfen monatlich den Betrag von 40 Euro nicht übersteigen. Die Leistung kann auch in
            Form einer Kostenerstattung erbracht werden.
          </p>
        </div>
      </section>
      {/* Newsletter */}
      <section id='newsletter'>
        <div className='title px-2'>
          <h2 className=''>Newsletter</h2>
          <p>Abonnieren Sie den kostenlosten Newsletter!</p>
        </div>
        <div className='newsletter-input'>
          <input type='email' name='email' placeholder='E-Mail-Adresse eingeben…' id='email' />
          <button className='' onClick={() => navigate('/NewsletterForm')}>
            Abonnieren
          </button>
        </div>
      </section>
      {/* Footer */}
      <Footer />
      {/* setting */}
      <Settings />
    </div>
  );
};

export default Homepage;
